import type { PropsWithChildren, ReactElement } from "react";
import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import {
    StyledCardHeaderContent,
    StyledCardHeaderTextWrapper,
    StyledCardHeaderWrapper,
    StyledCardIcon,
} from "app/pages/sales-intelligence/pages/home/components/common/HomeDataCard/styles";

export interface HomeDataCardHeaderBaseProps {
    iconName: IconName;
}

interface HomeDataCardHeaderProps extends HomeDataCardHeaderBaseProps {
    title: string | ReactElement;
}

const HomeDataCardHeader = ({ title, iconName, children }: PropsWithChildren<HomeDataCardHeaderProps>): ReactElement => {
    return (
        <StyledCardHeaderWrapper>
            <StyledCardHeaderTextWrapper>
                <StyledCardIcon>
                    <SWReactIcons
                        iconName={iconName}
                        size="md"
                    />
                </StyledCardIcon>

                <StyledCardHeaderContent>{title}</StyledCardHeaderContent>
            </StyledCardHeaderTextWrapper>

            {children}
        </StyledCardHeaderWrapper>
    );
}

export default HomeDataCardHeader;
